<template>
  <form @submit.prevent="submit">
    <base-content>
      <template v-slot:top>
        <hero-header heading="Payment details" />
      </template>

      <div class="row">
        <div class="col-sm-6">
          <p>
            You can make deposits using a debit card or a bank transfer.
            Debit cards are the quickest way to deposit but there is a limit of &pound;10,000 per transaction
            and you are required to use your 3DS for added security.
            For bank transfers, these can take a few days to show in your account but are usually much
            quicker and sometimes can show within a day.
          </p>
          <p class="mb-0">
            We need to first complete our other steps and set up your account before we take payment.
            If paying via bank transfer, you will be able to request a bank transfer with the unique
            reference we provide you to track your payment.
          </p>
        </div>
        <div class="col-sm-6 d-flex justify-content-center align-items-center">
          <div>
            <base-button block large :secondary="method === 'DebitCard'" @click="method = 'DebitCard'">
              Pay via Debit Card
            </base-button>
            <br>
            <base-button block large :secondary="method === 'BankTransfer'" @click="method = 'BankTransfer'">
              Pay via Bank Transfer
            </base-button>
          </div>
        </div>
      </div>

      <template v-slot:bottom>
        <div class="bg-light py-4">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-sm-6">
                Estimated time to complete: <strong>3 minutes</strong>
              </div>
              <div class="col-sm-6 text-right">
                <base-button :disabled="method === ''" icon-right="arrow-right" :loading="saving" primary submit>
                  Continue
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </base-content>
  </form>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  created () {
    this.account = this.$auth.user.accounts.find(account => account._id === this.$route.params.id)
  },

  data: () => ({
    account: {},
    method: '',
    saving: false
  }),

  components: {
    HeroHeader
  },

  methods: {
    change (method) {
      this.method = method
    },

    async submit () {
      this.saving = true

      await this.$store.dispatch('core/accounts/update', {
        _id: this.account._id,
        depositMethod: this.method
      })

      this.$router.push({ name: 'account.bank',
        params: {
          id: this.account._id
        } })
    }
  }
}
</script>
